import React, {useEffect, useRef} from 'react';
import {FixedSizeList} from 'react-window';

function Thumbnail({data, index, style}) {
    const {pdf, page, rotation, navigate, label} = data;
    const canvas = useRef();
    useEffect(() => {
        let active = true, task;
        const target = canvas.current;
        (async () => {
            const pdfPage = await pdf.getPage(index + 1);
            if (!active) return;
            const natural = pdfPage.getViewport({scale: 1, rotation: pdfPage.rotate + rotation});
            const viewport = pdfPage.getViewport({scale: Math.min(140 / natural.width, 140 / natural.height), rotation: pdfPage.rotate + rotation});
            target.width = viewport.width;
            target.height = viewport.height;
            task = pdfPage.render({canvas: target, canvasContext: target.getContext('2d'), viewport});
            await task.promise;
        })().catch(() => { /* The main viewer reports document errors. */ });
        return () => {
            active = false;
            task?.cancel();
            const release = () => { target.width = target.height = 0; };
            if (task) task.promise.catch(() => {}).then(release);
            else release();
        };
    }, [pdf, index, rotation]);
    return (
        <div style={style}>
            <button className="mg-pdf-thumbnail" aria-current={page === index + 1 ? 'page' : undefined}
                aria-label={label(index + 1)} onClick={() => navigate(index + 1)}>
                <canvas key={rotation} ref={canvas} aria-hidden="true"/><span>{index + 1}</span>
            </button>
        </div>
    );
}

export function PdfThumbnails({pdf, page, rotation, navigate, height, label}) {
    return <FixedSizeList height={Math.max(140, height)} width={180} itemCount={pdf.numPages} itemSize={178}
        itemData={{pdf, page, rotation, navigate, label}} overscanCount={2}>{Thumbnail}</FixedSizeList>;
}

export function PdfBookmarks({items, linkService}) {
    return <ul className="mg-pdf-bookmarks">{items.map((item, index) => {
        let href;
        try {
            const url = new URL(item.url);
            if (['https:', 'http:', 'mailto:'].includes(url.protocol)) href = url.href;
        } catch { /* Internal destinations use the link service. */ }
        return <li key={index}>
            {href ? <a href={href} target="_blank" rel="noopener noreferrer">{item.title}</a> :
                <button onClick={() => item.dest && linkService.goToDestination(item.dest)}>{item.title}</button>}
            {item.items?.length > 0 && <PdfBookmarks items={item.items} linkService={linkService}/>}
        </li>;
    })}</ul>;
}
